import AmbisTest from "@/modules/ambis_test/components/AmbisTest";
import ThemeForm from "@/modules/ambis_test/components/ThemeForm";
import DetailSkala from "@/modules/ambis_test/components/DetailSkala";
import Form from "@/modules/ambis_test/components/Form";
import SkalaForm from "@/modules/ambis_test/components/SkalaForm";
import CreateBundle from "@/modules/ambis_test/components/CreateBundle.vue";
import ListBundle from "@/modules/ambis_test/components/ListBundle.vue";
import DetailBundle from "@/modules/ambis_test/components/DetailBundle.vue";

export default [
    {
        path: "/ambis-test",
        name: "AmbisTest",
        component: AmbisTest,
    },
    {
        path: "/theme-form",
        name: "ThemeForm",
        component: ThemeForm,
    },
    {
        path: "/detail-skala",
        name: "DetailSkala",
        component: DetailSkala,
    },
    {
        path: "/form",
        name: "Form",
        component: Form,
    },
    {
        path: "/skala-form",
        name: "SkalaForm",
        component: SkalaForm,
    },
    {
        path: "/ambis-test/list-bundle",
        name: "ListBundle",
        component: ListBundle,
    },
    {
        path: "/ambis-test/create-bundle",
        name: "CreateBundle",
        component: CreateBundle,
    },
    {
        path: "/ambis-test/detail-bundle",
        name: "DetailBundle",
        component: DetailBundle,
    },
];



// WEBPACK FOOTER //
// ./src/modules/ambis_test/router/ambis_test.js